/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReasoningStepKindFinalJudgement = zod.enum(['final_judgement']);

export type ReasoningStepKindFinalJudgement = zod.input<typeof ReasoningStepKindFinalJudgement>;
export type ReasoningStepKindFinalJudgementOutput = zod.output<
	typeof ReasoningStepKindFinalJudgement
>;
